import Button from "@material-ui/core/Button";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function TransitTime({ ...props }) {
  const TransitTimes = [
    i18n.t("stepfour.1-3"),
    i18n.t("stepfour.3-5"),
    i18n.t("stepfour.7-10"),
  ];
  return (
    <>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion">{i18n.t("stepfour.label")}</p>
        </div>
        <div className="ContainerVertical MarginHorizontal NoPadding">
          {TransitTimes.map((item, i) => {
            return (
              <Button
                key={i}
                onClick={() => {
                  props.handleChange("transittime", item);
                  if (props.order.regular) {
                    props.handleNext(2);
                  } else props.handleNext();
                }}
                className={
                  item === props.order.transittime
                    ? "OldLace Wide MarginHorizontal"
                    : "TransparentWhite Wide MarginHorizontal"
                }
              >
                {item}
              </Button>
            );
          })}
        </div>
      </div>
      <div className="NavigationContainer FormWidth">
        <Button
          onClick={() => {
            if (props.order.regular === false) {
              props.handleBack(2);
            } else props.handleBack();
          }}
          className="TransparentWhite Medium"
        >
          {i18n.t("general.back")}
        </Button>
        <div className="ButtonContainer"></div>
      </div>
    </>
  );
}

export default withTranslation()(TransitTime);
